import {
    READ_NOTIFICATION,
    INSTANT_NOTIFICATION,
    OPEN_NOTIFICATIONS_WINDOW,
    CLOSE_NOTIFICATIONS_WINDOW,
    GET_MEMBER_NOTIFICATIONS_LIST
} from '../constants/notifications';

export default function notification(state = { list: [], showNotificationsWindow: false }, action) {
    switch (action.type) {
        case INSTANT_NOTIFICATION:
            return {
                ...state,
                list: [ action.data, ...state.list ]
            };
            
        case READ_NOTIFICATION:
            const readId = action.data.processedList[0]
            return {
                ...state,
                list: [...state.list.map(item => {
                    if (item.data.id === readId) {
                        item.data.is_read = 1;
                        return item;
                    }
                    return item;
                })],
            };
    
        case GET_MEMBER_NOTIFICATIONS_LIST:
            return {
                ...state,
                list: action.data.list,
            }
            
        case OPEN_NOTIFICATIONS_WINDOW:
            return {
                ...state,
                showNotificationsWindow: true
            };

        case CLOSE_NOTIFICATIONS_WINDOW:
            return {
                ...state,
                showNotificationsWindow: false
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/notifications.js